import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Add, Close, NotificationAdd } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import useJobsReadyForPickup from "../../../hooks/useJobsReadyForPickup";
import { useInView } from "react-intersection-observer";
import { useDebounce } from "use-debounce";
import TextFieldDebounced from "../../../components/TextFieldDebounced";
import InfiniteScrollerTable from "../../../components/InfiniteScroller/InfiniteScrollerTable";
import ListFooter from "../../../components/InfiniteScroller/ListFooter";

const SearchPickupHistoryByJobDialog = ({ open, jobDetails, handleClose }) => {
  const { ezorder, authToken } = useContext(AuthContext);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("ALL");

  const [jobs, onRefresh, refreshing, onLoadMore, loadingMore, total, hasMore] =
    useJobsReadyForPickup(authToken, 50, null, search, status);
  const [ref, inView, entry] = useInView({
    /* Optional options */
    threshold: 0.5, //Number between 0 and 1 indicating the percentage that should be visible before triggering. Can also be an array of numbers, to create multiple trigger points.
  });

  const [inViewDebounce] = useDebounce(inView, 1000);

  useEffect(() => {
    if (jobs.length > 0 && inView) {
      console.log("Footer Element In View. Load More...");
      onLoadMore();
    }
  }, [inViewDebounce]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth={true}
      fullScreen={isSmallScreen}
    >
      <DialogTitle>Pickup History By Job</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {/* <Typography variant="h4" component="div">
        Ready For Pickup
      </Typography> */}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "16px",
              marginBottom: "16px",
            }}
          >
            <Box sx={{ marginLeft: "8px", flex: 1 }}>
              <TextFieldDebounced
                fullWidth
                variant="outlined"
                label="Search"
                value={search}
                onChange={(e) => {
                  // updateSearch(e.target.value, status);
                  setSearch(e.target.value);
                }}
              />
            </Box>
            <TextField
              sx={{ width: "200px", marginLeft: "8px" }}
              select
              label="Status"
              value={status}
              onChange={(e) => {
                //   updateSearch(search, e.target.value);
                setStatus(e.target.value);
              }}
            >
              <MenuItem value={"PENDING"}>Pending</MenuItem>
              <MenuItem value={"ALL"}>All</MenuItem>
            </TextField>
          </Box>
          <InfiniteScrollerTable
            TableContainerComponent={Paper}
            // TableStyle={{ minWidth: "600px" }}
            TableHead={() => (
              <TableHead>
                <TableRow>
                  <TableCell align="left">ID</TableCell>
                  <TableCell align="left">Project</TableCell>
                  <TableCell align="left">Customer</TableCell>
                  {/* 
                        {includePaymentInfo && (
                          <TableCell align="left">Credit Type</TableCell>
                        )}
                        {includePaymentInfo && (
                          <TableCell align="left">Payment Status</TableCell>
                        )} */}
                  <TableCell align="left">Pickup Status</TableCell>

                  {/* <TableCell align="left">Date Approved</TableCell> */}
                </TableRow>
              </TableHead>
            )}
            items={jobs}
            renderRow={(item, index) => {
              let pickupStatus = "Pending";
              if (item.orderStatus.name == "CLOSED") {
                pickupStatus = "Fulfilled";
              } else {
                let pickupHistory = item.pickupHistory;
                if (pickupHistory.pickups && pickupHistory.pickups.length > 0) {
                  for (let pickup of pickupHistory.pickups) {
                    if (pickup.pickupStatus == "COMPLETED") {
                      pickupStatus = "Partially Completed";
                    }
                  }
                }
              }

              return (
                <>
                  <TableRow
                    align="left"
                    key={item.id}
                    hover
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      cursor: "pointer",
                    }}
                  >
                    <TableCell
                      align="left"
                      onClick={() => {
                        navigate(`/job-pickups/${item.id}`);
                      }}
                    >
                      {item.id}
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={() => {
                        navigate(`/job-pickups/${item.id}`);
                      }}
                    >
                      {item.project.name}
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={() => {
                        navigate(`/job-pickups/${item.id}`);
                      }}
                    >
                      {item.company && item.company.name
                        ? item.company.name
                        : "GUEST"}
                    </TableCell>

                    {/* {includePaymentInfo && (
                            <TableCell
                              align="left"
                              onClick={() => {
                                navigate(`/job-pickups/${item.id}`);
                              }}
                            >
                              {item.company.creditType}
                            </TableCell>
                          )}
                          {includePaymentInfo && (
                            <TableCell align="left">
                              <Link
                                sx={{ cursor: "pointer" }}
                                onClick={() => {
                                  navigate(`/invoices/${item.id}`);
                                }}
                              >
                                {item.invoiceId
                                  ? item.isPaid
                                    ? "Paid"
                                    : "Unpaid"
                                  : "Invoice Pending"}
                              </Link>
                            </TableCell>
                          )} */}
                    <TableCell
                      align="left"
                      onClick={() => {
                        navigate(`/job-pickups/${item.id}`);
                      }}
                    >
                      {pickupStatus}
                    </TableCell>

                    {/* <TableCell
                  align="left"
                  onClick={() => {
                    navigate(`/job-pickups/${item.id}`);
                  }}
                >
                  {moment(item.estimateApprovalDate)
                    .tz("America/Phoenix")
                    .format("MM/DD/YY")}
                </TableCell> */}
                  </TableRow>
                </>
              );
            }}
            onRefresh={onRefresh}
            onEndReached={onLoadMore}
            loading={refreshing || loadingMore}
            ListFooterComponent={() => {
              return <ListFooter hasMore={hasMore} onClick={onLoadMore} />;
            }}
          />
          {/* <PickupDialog
                  open={selectedJob != null}
                  jobDetails={selectedJob}
                  handleSchedule={(jobId) => {
                    setScheduleJobDialogData({ open: true, jobId: jobId });
                    setSelectedJob(null);
                  }}
                  handleClose={() => {
                    setSelectedJob(null);
                  }}
                /> */}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SearchPickupHistoryByJobDialog;
